import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {theme} from './Assets/css/mui';
import { ThemeProvider } from '@mui/material/styles';
import {SnackbarProvider} from 'notistack';
import {Provider} from  'react-redux';
import ReduxThunk from 'redux-thunk';
import {legacy_createStore as createStore, applyMiddleware} from 'redux';
import rootReducer from './Store';

const store = createStore( rootReducer, applyMiddleware(ReduxThunk))

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
      <SnackbarProvider autoHideDuration={3000}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Provider store = {store}>
          <App />
        </Provider>
      </SnackbarProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
